module.exports = __webpack_public_path__ + "img/element-column.d66af36.svg";